<template>
  <div class="page-container flex-column">
    <div class="col-0 pd10 flex-row item-center">
      <span class="mr5">文件名</span>
      <div class="mr10 flex-row">
        <el-input v-model="originalname" clearable placeholder="搜索关键词" size="mini" />
      </div>
      <span class="mr5">类型</span>
      <div class="mr10 flex-row"><el-input v-model="type" clearable placeholder="精确搜索" size="mini" /></div>
      <span v-if="isAdmin" class="mr5">上传人</span>
      <el-autocomplete
        v-if="isAdmin"
        v-model="uploader"
        clearable
        :fetch-suggestions="querySearch"
        size="mini"
        placeholder="搜索关键词"
        class="mr10"
      />
      <span class="mr5">建议职能模块</span>
      <div class="mr10 flex-row">
        <el-select v-model="category" size="mini" multiple filterable placeholder="请选择">
          <el-option v-for="(item, k) in categoryOpts" :key="k" :label="item" :value="item"> </el-option>
        </el-select>
      </div>
      <span class="mr5">建议行业</span>
      <div class="mr10 flex-row">
        <el-select v-model="industry" size="mini" multiple filterable placeholder="请选择">
          <el-option v-for="(item, k) in industryOpts" :key="k" :label="item" :value="item"> </el-option>
        </el-select>
      </div>
      <div><el-button :loading="pending" type="primary" size="mini" @click="search">搜索</el-button></div>
    </div>
    <FileTable
      ref="fileTable"
      :fetch-method="getFiles"
      :query="query"
      show-confuse
      show-download
      show-recommend
      class-name="col-1 scroll"
    />
  </div>
</template>

<script>
import FileTable from '../components/FileTable.vue'

export default {
  components: { FileTable },
  data() {
    return {
      dialogVisible: false,
      originalname: undefined,
      pending: false,
      type: undefined,
      uploader: undefined,
      category: undefined,
      industry: undefined,
      initUserOptions: false,
      categoryOpts: [],
      industryOpts: app.industries || [],
    }
  },
  computed: {
    isAdmin() {
      return window.app.user['角色'] && window.app.user['角色'].includes('管理员')
    },
    query() {
      const query = {}
      if (this.originalname) query.originalname = this.originalname
      if (this.type) query.type = this.type
      if (this.uploader) query.uploader = this.uploader
      if (this.category) query.建议职能模块 = this.category
      if (this.industry) query.建议行业 = this.industry
      return query
    },
  },
  async mounted() {
    if (!app.categories) {
      await app.getCats()
    }
    this.categoryOpts = app.categories.map(cate => cate['名称'])
  },
  methods: {
    getFiles(param) {
      return window.app.service('file').list(param)
    },
    search() {
      this.$refs.fileTable.getFiles()
    },
    async querySearch(queryString, cb) {
      if (!this.initUserOptions) {
        const users = await app.service('project').simpleUsers()
        const options = users.map((val, index) => ({
          label: val.account,
          value: val.account,
        }))
        this.userOptions = options
        this.initUserOptions = true
      }
      const userOptions = this.userOptions || []
      const results = queryString
        ? userOptions.filter(val => val.label && val.label.toLowerCase().includes(queryString.toLowerCase()))
        : userOptions
      cb(results)
    },
  },
}
</script>

<style scoped>
.file-list {
  flex: auto;
}
.file-handlers {
  padding: 10px 20px;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
</style>
